import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ticketBrands, getLvmamaKeyword, exportTicketData } from '@/api/order';
import { getCitys, getScenicType, getScenicLevel } from '@/api/goodsCenter';
export default {
  name: 'lvmamaConfig',
  props: {
    order_id: [Number, String],
    currentRowMenu: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    ruleType: String,
    entryType: String,
    // 平台配置  渠道列表 管理中心 订单规则
    /**
     * @description menuType 菜单类型
     * orderDetails - 订单列表-订单详情-订单规则
     * channelCardTypeManage - 管理中心 卡类型管理
     * saleCardTypeManage - 销售工具 卡类型管理
     * customerSet - 客户管理 - 客户列表 - 设置 - 营销参数管理
     */
    menuType: String,
    lvmamaType: String,
    // view - 查看 没有编辑功能  set - 允许编辑
    ruleInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menusInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasEditRule: Boolean
  },
  data: function data() {
    return {
      loading: false,
      dialogType: '',
      keywordTotal: 0,
      scenicTotal: 0,
      citys: [],
      levelList: [],
      scenicType: [],
      searchForm: {
        region_code: '',
        product_name: '',
        place_level: '',
        theme_id: '',
        page: 1,
        pagesize: 20
      },
      totalCount: 0,
      tableData: [],
      exportLoading: false
    };
  },
  methods: {
    changeTabs: function changeTabs(row) {
      var src = "".concat(this.$store.state.user.domainName, "/#/goodsCenter/ticket?activeName=tickets&product_id=").concat(row.product_id, "&region_code=").concat(this.searchForm.region_code);
      window.open(src, '_blank');
    },
    openDialog: function openDialog(openType) {
      this.dialogType = openType;
      switch (openType) {
        case 'setLvmamaChild':
        case 'viewLvmamaChild':
          this.$emit('setChildMenu', this.currentRowMenu.childrens, this.currentRowMenu, {
            openType: openType
          });
          break;
        case 'viewLvmamaKeyword':
        case 'setLvmamaKeyword':
          this.$emit('openLvmamaKeyword', this.currentRowMenu, {
            openType: openType
          });
          break;
      }
    },
    getConfig: function getConfig() {
      var _this = this;
      getCitys().then(function (res) {
        _this.citys = res.data.tree;
      });
      getScenicLevel().then(function (res) {
        _this.levelList = res.data.list;
      });
      getScenicType().then(function (res) {
        _this.scenicType = res.data.list;
      });
    },
    exportData: function exportData() {
      var _this2 = this;
      this.exportLoading = true;
      exportTicketData(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.searchForm), {}, {
        menu_id: this.currentRowMenu.id
      }), this.menuType).then(function (_) {
        _this2.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this2.exportLoading = false;
      });
    },
    getList: function getList() {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.loading = true;
        ticketBrands(_objectSpread(_objectSpread(_objectSpread({}, _this3.searchForm), _this3.ruleType === 'cardType' ? {
          rule_id: _this3.ruleInfo.id
        } : {
          order_id: _this3.order_id
        }), {}, {
          type: 'allow_brand',
          menu_id: _this3.currentRowMenu.id
        })).then(function (res) {
          var _res$data = res.data,
            _res$data$data = _res$data.data,
            data = _res$data$data === void 0 ? [] : _res$data$data,
            _res$data$pages = _res$data.pages,
            pages = _res$data$pages === void 0 ? {} : _res$data$pages;
          _this3.tableData = data;
          _this3.totalCount = Number(pages.total_count || 0);
          resolve(res.data);
        }).finally(function () {
          _this3.loading = false;
        });
      });
    },
    pageChange: function pageChange() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.searchForm.page = page;
      this.getList();
    },
    searchData: function searchData(type) {
      type === 'reset' && this.$refs['searchForm'].resetFields();
      this.pageChange(1);
    },
    sizeChange: function sizeChange(size) {
      this.searchForm.pagesize = size;
      this.pageChange(1);
    },
    getKeywordTotal: function getKeywordTotal() {
      var _this4 = this;
      getLvmamaKeyword(this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }).then(function (res) {
        _this4.keywordTotal = res.data.length;
        if (_this4.keywordTotal > 0) {
          // 获取黑名单关键词过滤景区数量
          ticketBrands(_objectSpread(_objectSpread({}, _this4.ruleType === 'cardType' ? {
            rule_id: _this4.ruleInfo.id
          } : {
            order_id: _this4.order_id
          }), {}, {
            type: 'not_allow_brand',
            menu_id: _this4.currentRowMenu.id,
            page: 1,
            pagesize: 20
          })).then(function (res) {
            var _res$data$pages2 = res.data.pages,
              pages = _res$data$pages2 === void 0 ? {} : _res$data$pages2;
            _this4.scenicTotal = Number(pages.total_count || 0);
          });
        }
      });
    },
    loadData: function loadData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this5.searchForm.page = 1;
              _this5.getList(); // 获取可用品牌数据
              _this5.getKeywordTotal(); // 获取关键词总数
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.getConfig();
    this.loadData();
  },
  computed: {
    childMenuTotal: function childMenuTotal() {
      var _this$currentRowMenu$ = this.currentRowMenu.childrens,
        childrens = _this$currentRowMenu$ === void 0 ? [] : _this$currentRowMenu$;
      return childrens.filter(function (i) {
        return i.selected == 1;
      }).length;
    },
    hasExportRole: function hasExportRole() {
      var authEnum = {
        orderDetails: '/orders/card-rule-extend/scenicspots-v2-export',
        channelCardTypeManage: '/orders/card-rule-extend/scenicspots-v2-common-export',
        saleCardTypeManage: '/orders/card-rule-extend/scenicspots-v2-sale-export'
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        // 产品要求 只需要在这三个页面中判断权限即可
        var rolePath = authEnum[this.menuType];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    }
  }
};